/**
 * Roles's keys
 */
export const StorageRoles = {
  roles: 'roles',
  /** Serialized GET /account/userInfo `profiles` for guards and shell when only storage is available. */
  profiles: 'accountUserProfiles',
};
